import React from "react";

import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

type Props = { className?: string };

export const UnorderedList = (props: SvgIconProps & Props) => {
    return (
        <SvgIcon {...props} variant={"stroke"}>
            <path d="M8 7H20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 12H20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 17H20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 7H4.01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 12H4.01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 17H4.01" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
};
